module.exports = {
	"rootElement": "nfe-issuer",
	"identification": {
		"rootElement": "identification",
		"nat_op": "nat-opt",
		"ref_key": "input-nfe-ref-key"
	},
	"items": {},
	"payments": {},
	"finish": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/views/Fiscal/NFe/Issuer/test.keys.json
// module id = 1780
// module chunks = 0